import signals from "signals"
import ajax from "ajax"

export default (new_terminology, old_terminology, location) => {
  signals.emit(
    "kenhub.terminology_changed",
    {old_terminology, new_terminology, location}
  )
  return ajax.post(
    `/${window.gon.locale}/profile/change_term_language.json`,
    {term_language: new_terminology},
  )
}
